module.exports = __webpack_public_path__ + "0d0ac54c4acaab7536baee3de6fbee11.svg";